import { render, staticRenderFns } from "./IcoFaceDisgust.vue?vue&type=template&id=113f09ac"
import script from "./IcoFaceDisgust.vue?vue&type=script&lang=js"
export * from "./IcoFaceDisgust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports